import React, { useState, useEffect } from 'react';
import {
    countUsersAttemptedByTestSeriesExamTestTypeSubCategoryId,
    countUsersSubmittedByTestSeriesExamTestTypeSubCategoryId,
    getAverageScoreByTestSeriesExamTestTypeSubCategoryId,
    getHighestScoreByTestSeriesExamTestTypeSubCategoryId,
    getLowestScoreByTestSeriesExamTestTypeSubCategoryId,
    getAverageTimeTakenByTestSeriesExamTestTypeSubCategoryId,
    getPaidUsersCountByTestSeriesExamTestTypeSubCategoryId,
    getTop10PerformingTestSeriesBySubCategoryBasedOnAvgScore
} from '../../../api/testSeries/subcategory';
import { useParams } from 'react-router-dom';
const SubCategoryStats = ({ }) => {
    const { id: categoryId } = useParams()
    const [usersAttempted, setUsersAttempted] = useState(0);
    const [usersSubmitted, setUsersSubmitted] = useState(0);
    const [averageScore, setAverageScore] = useState(0);
    const [highestScore, setHighestScore] = useState(0);
    const [lowestScore, setLowestScore] = useState(0);
    const [averageTimeTaken, setAverageTimeTaken] = useState(0);
    const [paidUsersCount, setPaidUsersCount] = useState(0);
    const [topPerformingTestSeries, setTopPerformingTestSeries] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const usersAttemptedResponse = await countUsersAttemptedByTestSeriesExamTestTypeSubCategoryId(categoryId);
            if (usersAttemptedResponse.status) {
                setUsersAttempted(usersAttemptedResponse.data);
            }

            const usersSubmittedResponse = await countUsersSubmittedByTestSeriesExamTestTypeSubCategoryId(categoryId);
            if (usersSubmittedResponse.status) {
                setUsersSubmitted(usersSubmittedResponse.data);
            }

            const averageScoreResponse = await getAverageScoreByTestSeriesExamTestTypeSubCategoryId(categoryId);
            if (averageScoreResponse.status) {
                setAverageScore(averageScoreResponse.data);
            }

            const highestScoreResponse = await getHighestScoreByTestSeriesExamTestTypeSubCategoryId(categoryId);
            if (highestScoreResponse.status) {
                setHighestScore(highestScoreResponse.data);
            }

            const lowestScoreResponse = await getLowestScoreByTestSeriesExamTestTypeSubCategoryId(categoryId);
            if (lowestScoreResponse.status) {
                setLowestScore(lowestScoreResponse.data);
            }

            const averageTimeTakenResponse = await getAverageTimeTakenByTestSeriesExamTestTypeSubCategoryId(categoryId);
            if (averageTimeTakenResponse.status) {
                setAverageTimeTaken(averageTimeTakenResponse.data);
            }

            const paidUsersCountResponse = await getPaidUsersCountByTestSeriesExamTestTypeSubCategoryId(categoryId);
            if (paidUsersCountResponse.status) {
                setPaidUsersCount(paidUsersCountResponse.data);
            }

            const topPerformingTestSeriesResponse = await getTop10PerformingTestSeriesBySubCategoryBasedOnAvgScore(categoryId);
            if (topPerformingTestSeriesResponse.status) {
                setTopPerformingTestSeries(topPerformingTestSeriesResponse.data);
            }
        };

        fetchData();
    }, [categoryId]);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Users Attempted</h5>
                            <p className="card-text">{usersAttempted}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Users Submitted</h5>
                            <p className="card-text">{usersSubmitted}</p>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Paid Users Count</h5>
                            <p className="card-text">{paidUsersCount}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Highest Score</h5>
                            <p className="card-text">{highestScore}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Average Score</h5>
                            <p className="card-text">{parseFloat(averageScore).toFixed(2)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Lowest Score</h5>
                            <p className="card-text">{lowestScore}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Average Time Taken</h5>
                            <p className="card-text">{parseFloat(averageTimeTaken).toFixed(2)}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};
export default SubCategoryStats;
